<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="8">
        <v-container class="max-width">
          <v-pagination
            v-model="page"
            @input="changed"
            class="my-4"
            :length="paginationLen"
            :total-visible="10"
          ></v-pagination>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
  <!-- <paginate
    :page-count="10"
    :container-class="'pagination'"
    :click-handler="changed"
    :page-class="'page-item'"
  >
  </paginate> -->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      page: this.$store.getters.getCurrentPage,
    };
  },
  computed: {
    ...mapGetters(["getPageSize"]),
    paginationLen: function () {
      return this.$store.getters.paginationLen;
    },
  },
  methods: {
    changed: function () {
      // console.log("Page changed:" + this.page);
      this.$store.dispatch({ type: "setCurrentPage", page: this.page });
      this.$emit("changed");
    },
  },
};
</script>

<style lang="css">
.pagination {
}
.page-item {
}
</style>
